module.exports = __webpack_public_path__ + "media/images/static/our_work/03_store-1827523c48676d21c390af55b49b3e4a.png";